"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG3D_JUSTIFICATION = void 0;
var TAG3D_JUSTIFICATION;
(function (TAG3D_JUSTIFICATION) {
    TAG3D_JUSTIFICATION["TOP_LEFT"] = "TL";
    TAG3D_JUSTIFICATION["TOP_CENTER"] = "TC";
    TAG3D_JUSTIFICATION["TOP_RIGHT"] = "TR";
    TAG3D_JUSTIFICATION["MIDDLE_LEFT"] = "ML";
    TAG3D_JUSTIFICATION["MIDDLE_CENTER"] = "MC";
    TAG3D_JUSTIFICATION["MIDDLE_RIGHT"] = "MR";
    TAG3D_JUSTIFICATION["BOTTOM_LEFT"] = "BL";
    TAG3D_JUSTIFICATION["BOTTOM_CENTER"] = "BC";
    TAG3D_JUSTIFICATION["BOTTOM_RIGHT"] = "BR";
})(TAG3D_JUSTIFICATION || (exports.TAG3D_JUSTIFICATION = TAG3D_JUSTIFICATION = {}));
//# sourceMappingURL=interfaces.js.map